import {
  type Link,
  type LinkInternal,
  MarketCountryCode,
  type Price,
} from '../../api-models'
import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

/**
 * Returns general information about a product
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/product-page-api/definition#tag/product/operation/getProductv2}
 */
export const getProduct = createHttpEndpoint<GetProductResponse>({
  defaultQueryParams: { include: 'checks,obsolescence,waterproof,accessories' },
  method: 'GET',
  operationId: 'getProductv2',
  path: '/bm/product/v2/:productId',
})

export type GetProductResponse = HttpResponsePayload<{
  id: string
  legacyId: string
  link: LinkInternal
  links: Partial<Record<MarketCountryCode, LinkInternal>>
  type: 'refurbished' | 'accessory'
  title: string
  rawTitle: string
  model: string
  subTitleElements: Array<string>
  priceWhenNew?: Price
  isSwapEligible: boolean
  images: Array<{
    alt: string
    url: string
  }>
  compatibleCarriers: Array<{
    name: string
    logo: string
    isSimLocked: boolean
  }>
  trackingDetails: {
    brand: string
    categories: Array<string>
    category3MarketplaceCategory_ID: number
    category3Name: string
    color: string
  }
  tags: Array<string>
  insurancesOffers: {
    additionalBenefits?: Array<string>
  }
  eWaste: string
  eWasteData?: {
    sentence: string
    link: Link
  }
  description: string
  mobilePlan?: {
    listingId: number
  }
  vatIncluded?: boolean
}>
